export default __webpack_public_path__ + "images/send_now_design.e54be0a06f2fbbf8c4c35ab2cd4149bf.svg";